/* Ridgeborn size guide: category + brand tabs, AU/UK/US/EU and cm/in switches, find-my-size */
(function () {
  var SYS = ['AU', 'UK', 'US', 'EU'];

  function store(k, v) {
    try { if (v === undefined) return localStorage.getItem('rbsg-' + k); localStorage.setItem('rbsg-' + k, v); } catch (e) { return null; }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function num(v) {
    var m = String(v).trim().match(/^(\d+(?:\.\d+)?)(?:\s*[-–]\s*(\d+(?:\.\d+)?))?$/);
    if (!m) return null;
    return { lo: +m[1], hi: m[2] ? +m[2] : +m[1] };
  }
  function round(x, unit) {
    return unit === 'in' ? String(Math.round(x / 2.54 * 2) / 2) : String(Math.round(x * 10) / 10);
  }
  function fmt(v, unit) {
    var n = num(v);
    if (!n) return v;
    return n.lo === n.hi ? round(n.lo, unit) : round(n.lo, unit) + '–' + round(n.hi, unit);
  }
  function parse(c) {
    var lines = String(c.chart || '').split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean);
    var rows = lines.map(function (l) { return l.split('|').map(function (x) { return x.trim(); }); });
    var head = rows.shift() || [];
    var cols = head.map(function (h, i) {
      var m = h.match(/^(.*?)\s*\(?cm\)?$/i);
      if (m && m[1]) return { i: i, name: m[1].trim(), type: 'm' };
      if (SYS.indexOf(h.toUpperCase()) > -1) return { i: i, name: h.toUpperCase(), type: 's' };
      return { i: i, name: h, type: 'x' };
    });
    var sys = cols.filter(function (k) { return k.type === 's'; });
    var same = sys.length > 1 && rows.every(function (r) { return sys.every(function (k) { return r[k.i] === r[sys[0].i]; }); });
    var fit = String(c.fit || '').split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
    var fitCols = cols.filter(function (k) { return k.type === 'm' && fit.indexOf(k.name.toLowerCase()) > -1; });
    return { cols: cols, rows: rows, sys: sys, same: same, fitCols: fitCols };
  }
  function col(p, name) {
    for (var i = 0; i < p.cols.length; i++) if (p.cols[i].name === name) return p.cols[i];
    return null;
  }

  // Which row fits a body measurement m (cm) for one column
  function pick(p, k, m, down) {
    var vals = p.rows.map(function (r) { var n = num(r[k.i]); return n ? n.hi : NaN; });
    var n = vals.length;
    if (m < vals[0] - 4) return { i: 0, below: true };
    if (m <= vals[0] + 1) return { i: 0 };
    for (var i = 1; i < n; i++) {
      if (Math.abs(m - vals[i]) <= 1) return { i: i };
      if (m < vals[i]) {
        if (Math.abs(m - vals[i - 1]) <= 1) return { i: i - 1 };
        return { i: down ? i - 1 : i, between: [i - 1, i] };
      }
    }
    if (m <= vals[n - 1] + 2) return { i: n - 1 };
    return { i: n - 1, above: true };
  }

  function init(root) {
    var data = [];
    try { data = JSON.parse(root.querySelector('[data-sg-data]').textContent); } catch (e) { data = []; }
    data.sort(function (a, b) { return (a.position || 99) - (b.position || 99); });
    data.forEach(function (c) { c.p = parse(c); });

    var catBtns = [].slice.call(root.querySelectorAll('[data-cat]'));
    var brandsEl = root.querySelector('[data-sg-brands]');
    var sysSeg = root.querySelector('[data-sg-systems]');
    var unitSeg = root.querySelector('[data-sg-units]');
    var sameNote = root.querySelector('[data-sg-same]');
    var titleEl = root.querySelector('[data-sg-title]');
    var srcEl = root.querySelector('[data-sg-source]');
    var tableEl = root.querySelector('[data-sg-table]');
    var notesEl = root.querySelector('[data-sg-notes]');
    var shopEl = root.querySelector('[data-sg-shop]');
    var modeBtns = [].slice.call(root.querySelectorAll('[data-mode]'));
    var form = root.querySelector('[data-sg-form]');
    var result = root.querySelector('[data-sg-result]');
    var wa = root.querySelector('[data-sg-wa]');
    var empty = root.querySelector('[data-sg-empty]');

    var st = {
      cat: null, chart: null, mode: 'measure', hl: null,
      sys: store('sys') || root.dataset.defaultSystem || 'AU',
      unit: store('unit') || root.dataset.defaultUnit || 'cm'
    };

    function chartsIn(cat) { return data.filter(function (c) { return c.category === cat; }); }
    function sysLabel(c, r) {
      var p = c.p;
      if (!p.sys.length) return r[0];
      var k = col(p, st.sys) || p.sys[0];
      return (p.same ? '' : k.name + ' ') + r[k.i];
    }

    function setCat(cat, handle) {
      var list = chartsIn(cat);
      st.cat = cat;
      catBtns.forEach(function (b) { b.setAttribute('aria-selected', b.dataset.cat === cat ? 'true' : 'false'); });
      brandsEl.innerHTML = list.map(function (c) {
        return '<button type="button" role="tab" data-h="' + esc(c.handle) + '"><b>' + esc(c.brand) + '</b><span>' + esc(c.title) + '</span></button>';
      }).join('');
      brandsEl.hidden = list.length < 2;
      [].forEach.call(brandsEl.children, function (b) { b.addEventListener('click', function () { setChart(b.dataset.h, true); }); });
      var btn = catBtns.filter(function (b) { return b.dataset.cat === cat; })[0];
      if (btn && btn.dataset.shop) { shopEl.href = btn.dataset.shop; shopEl.textContent = btn.dataset.shopLabel || 'Shop now'; shopEl.hidden = false; }
      else shopEl.hidden = true;
      if (!list.length) { empty.hidden = false; root.querySelector('.rb-sg__grid').hidden = true; return; }
      empty.hidden = true; root.querySelector('.rb-sg__grid').hidden = false;
      var pickH = list.some(function (c) { return c.handle === handle; }) ? handle : list[0].handle;
      setChart(pickH, false);
    }

    function setChart(h, push) {
      var c = data.filter(function (x) { return x.handle === h; })[0];
      if (!c) return;
      st.chart = c; st.hl = null;
      [].forEach.call(brandsEl.children, function (b) { b.setAttribute('aria-selected', b.dataset.h === h ? 'true' : 'false'); });
      titleEl.textContent = c.title;
      srcEl.textContent = c.source ? 'Measurements from: ' + c.source : '';
      notesEl.innerHTML = String(c.notes || '').split(/\r?\n/).filter(function (l) { return l.trim(); }).map(function (l) { return '<li>' + esc(l) + '</li>'; }).join('');
      notesEl.hidden = !notesEl.children.length;
      sysSeg.hidden = !c.p.sys.length || c.p.same;
      sameNote.hidden = !c.p.same;
      unitSeg.hidden = !c.p.cols.some(function (k) { return k.type === 'm'; });
      var canMeasure = c.p.fitCols.length > 0;
      modeBtns.forEach(function (b) { if (b.dataset.mode === 'measure') b.hidden = !canMeasure; });
      st.mode = canMeasure ? 'measure' : 'convert';
      if (push && window.history && history.replaceState) {
        try { var u = new URL(location.href); u.searchParams.set('chart', h); history.replaceState(null, '', u.pathname + u.search + '#size-tool'); } catch (e) {}
      }
      renderToggles(); renderTable(); renderForm(); result.innerHTML = ''; result.hidden = true; updateWa();
    }

    function renderToggles() {
      [].forEach.call(sysSeg.querySelectorAll('button'), function (b) { b.setAttribute('aria-pressed', b.dataset.sys === st.sys ? 'true' : 'false'); });
      [].forEach.call(unitSeg.querySelectorAll('button'), function (b) { b.setAttribute('aria-pressed', b.dataset.unit === st.unit ? 'true' : 'false'); });
      modeBtns.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.mode === st.mode ? 'true' : 'false'); });
    }

    function renderTable() {
      var c = st.chart, p = c.p;
      var k = col(p, st.sys) || p.sys[0];
      var u = st.unit === 'in' ? 'in' : 'cm';
      var others = p.cols.filter(function (x) { return x.type !== 's'; });
      var sizeHead = p.same || !k ? 'Size' : 'Size <small>' + k.name + '</small>';
      var h = '<thead><tr><th scope="col" class="is-size">' + sizeHead + '</th>' + others.map(function (x) {
        return '<th scope="col">' + esc(x.name) + (x.type === 'm' ? ' <small>' + u + '</small>' : '') + '</th>';
      }).join('') + '</tr></thead><tbody>';
      p.rows.forEach(function (r, i) {
        h += '<tr' + (st.hl === i ? ' class="is-hl"' : '') + '><th scope="row" class="is-size">' + esc(k ? r[k.i] : r[0]) + '</th>' + others.map(function (x) {
          return '<td>' + esc(x.type === 'm' ? fmt(r[x.i], u) : r[x.i]) + '</td>';
        }).join('') + '</tr>';
      });
      tableEl.innerHTML = h + '</tbody>';
    }

    function renderForm() {
      var c = st.chart, p = c.p, u = st.unit === 'in' ? 'inches' : 'cm';
      renderToggles();
      if (st.mode === 'measure') {
        form.innerHTML = p.fitCols.map(function (k, n) {
          return '<label class="rb-sg__field"><span>' + (/^(around|your)\b/i.test(k.name) ? esc(k.name) : 'Your ' + esc(k.name.toLowerCase())) + '</span><span class="rb-sg__inp"><input type="number" inputmode="decimal" step="0.5" min="0" name="m' + n + '" required><em>' + u + '</em></span></label>';
        }).join('') + '<button class="btn btn-gold" type="submit">Find my size</button>';
      } else {
        var opts = p.cols.filter(function (k) { return k.type !== 'm'; }).filter(function (k) {
          return !(p.same && k.type === 's' && k !== p.sys[0]);
        });
        form.innerHTML = '<label class="rb-sg__field"><span>Size system</span><select name="sys">' + opts.map(function (k) {
          var lab = p.same && k.type === 's' ? 'Size' : k.name;
          return '<option value="' + k.i + '"' + (k.name === st.sys ? ' selected' : '') + '>' + esc(lab) + '</option>';
        }).join('') + '</select></label><label class="rb-sg__field"><span>Size you wear</span><select name="val"></select></label><button class="btn btn-gold" type="submit">Convert</button>';
        var sel = form.querySelector('[name=sys]'), val = form.querySelector('[name=val]');
        var fill = function () {
          var i = +sel.value, seen = {};
          val.innerHTML = p.rows.map(function (r) { return r[i]; }).filter(function (v) { if (!v || v === '–' || v === '-' || seen[v]) return false; seen[v] = 1; return true; })
            .map(function (v) { return '<option>' + esc(v) + '</option>'; }).join('');
        };
        sel.addEventListener('change', fill); fill();
      }
    }

    function show(i, why) {
      var c = st.chart, p = c.p, r = p.rows[i];
      st.hl = i; renderTable();
      // First column = the size customers pick when ordering on the store
      var first = p.cols[0];
      var orderLab = r[first.i] + (first.type === 's' && !p.same ? ' (' + first.name + ')' : '');
      var rest = p.cols.filter(function (k) { return k !== first && k.type !== 'm' && r[k.i] && r[k.i] !== '–' && r[k.i] !== '-'; });
      if (p.same) rest = rest.filter(function (k) { return k.type !== 's'; });
      var conv = rest.map(function (k) { return k.name + ' ' + r[k.i]; }).join(' · ');
      result.innerHTML = '<div class="rb-sg__big"><small>Order this ' + esc(c.brand) + ' size</small><b>' + esc(orderLab) + '</b></div>' +
        (conv ? '<p class="rb-sg__conv">' + (p.same ? 'Same size in AU, UK, US and EU' + (conv ? ' · ' : '') : 'That is ') + esc(conv) + '</p>' : (p.same ? '<p class="rb-sg__conv">Same size in AU, UK, US and EU</p>' : '')) +
        (why ? '<p class="rb-sg__why">' + why + '</p>' : '');
      result.hidden = false;
      st.last = orderLab;
      updateWa();
      var row = tableEl.querySelector('.is-hl');
      if (row && window.matchMedia('(max-width: 989px)').matches === false) row.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var c = st.chart, p = c.p;
      if (st.mode === 'convert') {
        var ci = +form.querySelector('[name=sys]').value, v = form.querySelector('[name=val]').value;
        for (var i = 0; i < p.rows.length; i++) if (p.rows[i][ci] === v) { st.meas = ''; return show(i, ''); }
        return;
      }
      var down = /down/i.test(c.between || '');
      var best = null, notes = [], meas = [];
      p.fitCols.forEach(function (k, n) {
        var raw = parseFloat(form.querySelector('[name=m' + n + ']').value);
        if (!(raw > 0)) return;
        var cm = st.unit === 'in' ? raw * 2.54 : raw;
        meas.push(k.name + ' ' + raw + (st.unit === 'in' ? ' in' : ' cm'));
        var r = pick(p, k, cm, down);
        r.k = k;
        if (!best || r.i > best.i) best = r;
        notes.push(r);
      });
      if (!best) return;
      st.meas = meas.join(', ');
      var lab = function (i) { return esc(sysLabel(c, p.rows[i])); };
      var why = '';
      if (best.above) why = 'You measure above our largest ' + esc(c.brand) + ' size. Message us on WhatsApp and we will check what we can get in for you.';
      else if (best.below) why = 'You measure below our smallest ' + esc(c.brand) + ' size, so this may be loose. Message us and we will check other options.';
      else if (best.between) why = 'You are between ' + lab(best.between[0]) + ' and ' + lab(best.between[1]) + '. For this item we suggest ' + (down ? 'the smaller size' : 'going up a size for room to move') + '.';
      else why = /^around/i.test(best.k.name) ? 'Matches your measurement.' : 'Matches your ' + esc(best.k.name.toLowerCase()) + ' measurement.';
      if (notes.length > 1 && notes.some(function (r) { return r.i !== best.i; })) why += ' Your ' + esc(best.k.name.toLowerCase()) + ' needs the bigger size, so go with that one.';
      show(best.i, why);
    });

    function updateWa() {
      if (!wa) return;
      var num = root.dataset.wa;
      if (!num) { wa.hidden = true; return; }
      var t = (root.dataset.waText || 'Hi Ridgeborn, can you help me with sizing?') + ' Item: ' + st.chart.title + '.';
      if (st.meas) t += ' My measurements: ' + st.meas + '.';
      if (st.last) t += ' The size guide suggested ' + st.last + '.';
      wa.href = 'https://wa.me/' + num + '?text=' + encodeURIComponent(t);
    }

    catBtns.forEach(function (b) { b.addEventListener('click', function () { setCat(b.dataset.cat); }); });
    [].forEach.call(sysSeg.querySelectorAll('button'), function (b) {
      b.addEventListener('click', function () {
        st.sys = b.dataset.sys; store('sys', st.sys); renderToggles(); renderTable();
        if (st.mode === 'measure') { if (!result.hidden) resubmit(); }
        else { var keep = !result.hidden && st.hl != null ? st.hl : null; renderForm(); if (keep != null) show(keep, ''); }
      });
    });
    [].forEach.call(unitSeg.querySelectorAll('button'), function (b) {
      b.addEventListener('click', function () {
        var from = st.unit; st.unit = b.dataset.unit; store('unit', st.unit); renderToggles(); renderTable();
        if (st.mode === 'measure') {
          var vals = [].map.call(form.querySelectorAll('input'), function (i) { return parseFloat(i.value); });
          renderForm();
          [].forEach.call(form.querySelectorAll('input'), function (inp, n) {
            var v = vals[n]; if (!(v > 0) || from === st.unit) { if (v > 0) inp.value = v; return; }
            inp.value = st.unit === 'in' ? Math.round(v / 2.54 * 2) / 2 : Math.round(v * 2.54);
          });
          if (!result.hidden) resubmit();
        }
      });
    });
    function resubmit() { form.dispatchEvent(new Event('submit', { cancelable: true })); }
    modeBtns.forEach(function (b) { b.addEventListener('click', function () { st.mode = b.dataset.mode; renderForm(); result.hidden = true; st.hl = null; renderTable(); }); });
    [].forEach.call(document.querySelectorAll('[data-sg-jump]'), function (a) {
      a.addEventListener('click', function () { setCat(a.dataset.sgJump); });
    });

    var want = null;
    try { want = new URL(location.href).searchParams.get('chart'); } catch (e) {}
    var wc = data.filter(function (c) { return c.handle === want; })[0];
    var startCat = wc ? wc.category : (catBtns[0] && catBtns[0].dataset.cat);
    if (startCat) setCat(startCat, wc && wc.handle);
    if (wc) setTimeout(function () { root.scrollIntoView({ block: 'start' }); }, 50);
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-sg]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
